import { format } from "date-fns";
import React from "react";
import { useForm } from "react-hook-form";
import { ActivityDetailsView } from "../../app/GeneratedApi";
import { getErrorMessage } from "../../utils/errorUtils";
import { trimAllStringFields } from "../../utils/stringUtils";
import {
  SaveTemplateDialogForm,
  SaveTemplateDialogProps,
} from "./SaveTemplateDialog.types";
import { useCampaignPageView } from "../../pages/WorkflowsBuilderPage/CampaignBuilder/CampaignPage.context";
import { usePostActivityMutation } from "../../app/useGeneratedApi";

export function useSaveTemplateDialog(props: SaveTemplateDialogProps) {
  const { open, onClose, template } = props;

  const { details } = useCampaignPageView();

  const [errorMessage, setErrorMessage] = React.useState<string>();

  const form = useForm<SaveTemplateDialogForm>({
    defaultValues: {
      name: "",
    },
  });

  const { mutateAsync: saveTemplateMutateAsync, isLoading: saving } =
    usePostActivityMutation({
      onError(e: any) {
        setErrorMessage(getErrorMessage(e));
      },
      onSuccess() {},
    });

  const save = React.useCallback(async () => {
    const valid = await form.trigger();
    if (!valid) {
      return;
    }

    const { name } = trimAllStringFields(form.getValues());
    const activity: ActivityDetailsView = {
      name,
      subject: name,
      templateHtml: template?.templateHtml ?? "",
      templateCss: template?.templateCss ?? "",
      editorType: template?.editorType ?? "DRAG_AND_DROP",
    };

    try {
      await saveTemplateMutateAsync({ data: activity });
      onClose();
    } catch (error) {}
  }, [form, onClose, saveTemplateMutateAsync, template]);

  const closeError = React.useCallback(() => {
    setErrorMessage(undefined);
  }, []);

  React.useEffect(() => {
    if (open) {
      setErrorMessage(undefined);
      const proposedName = template?.name?.startsWith(details?.name || "")
        ? details?.name
        : template?.name;
      form.reset({
        name: `${proposedName}_${format(new Date(), "SSS")}`,
      });
    }
  }, [details?.name, form, open, template?.name]);

  return {
    form,
    save,
    saving,
    errorMessage,
    closeError,
  };
}
